import { apiFetch } from '../../utils/api';

export const formularioCategoriaOrdenSlice = (set, get) => ({
  obtenerCategoriaOrden: async () => {
    set({ isLoading: true });
    try {
      const data = await apiFetch("/api/product-categories/order");
      if (data && data.status) {
        const sucursales = Array.isArray(data.data?.sucursales) ? data.data.sucursales : [];
        const categorias = Array.isArray(data.data?.categorias) ? data.data.categorias : [];
        const sucursalesOptions = sucursales.map((item) => ({ value: item.id, label: item.nombre }));

        set({
          sucursales: sucursalesOptions,
          sucursalesOrden: sucursalesOptions[0] ? [sucursalesOptions[0]] : [],
          categoriasOrden: categorias,
          categoriasOrdenTemp: categorias,
        });
      }
    } catch (error) {
      console.error('Error al obtener orden de categorías:', error);
    } finally {
      set({ isLoading: false });
    }
  },

  handleSave: async () => {
    const currentBranchId = get().sucursalesOrden[0]?.value;
    if (!currentBranchId) {
      window.notie?.alert?.({ type: 'warning', text: 'Selecciona una sucursal para guardar el orden' });
      return;
    }

    const elOrden = get().categoriasOrdenTemp.map((item) => ({
      cp: item.id,
      suc: item.branchId,
      orden: item.orden,
    }));

    try {
      const data = await apiFetch("/api/product-categories/order", {
        method: "POST",
        body: JSON.stringify({ orden: elOrden }),
      });

      if (data && data.status) {
        set({ categoriasOrden: [...get().categoriasOrdenTemp] });
        window.notie?.alert?.({ type: 'success', text: 'Orden guardado correctamente' });
      } else {
        window.notie?.alert?.({ type: 'error', text: data?.message || 'Error al guardar el orden' });
      }
    } catch (error) {
      console.error('Error al guardar orden:', error);
      window.notie?.alert?.({ type: 'error', text: 'Error al guardar el orden' });
    }
  },
});
